export default __webpack_public_path__ + "df72003.png";